import __ from 'localisation';

export const fatcaOptions = [
  {
    id: 'active_nffe',
    title: __('fatca_active_nffe'),
  },
  {
    id: 'passive_nffe_no_us',
    title: __('fatca_passive_nffe_no_us'),
  },
  {
    id: 'passive_nffe_us',
    title: __('fatca_passive_nffe_us'),
  },
  {
    id: 'other',
    title: __('fatca_other'),
  },
];
